module.exports = __webpack_public_path__ + "img/Icons-headphone.7d5ab67c.svg";